export default "/images/5f54abc9e93445d35af3e8ba7622cbe0.avif";